module.exports = __webpack_public_path__ + "static/img/es.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/es.svg
// module id = l0N4
// module chunks = 0